import { WindingDir } from "geom/core";
import { planarGraphHalfEdgeStripToPolyLine2, planarGraphTracePerimeter } from "geom/planarGraph";
import { polygonPlanarGraphNew } from "geom/polygonPlanarGraph";
import { polyLine2Reverse, polyLine2WindingDir } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";

export function makeBlockPerimeterFromRoomOutlines(roomOutlines: PolyLine2[]): PolyLine2[] {
  if (roomOutlines.length === 0) {
    return [];
  }

  const graph = polygonPlanarGraphNew(roomOutlines);
  const loops = planarGraphTracePerimeter(graph.planarGraph);

  return loops.faceHalfEdges
    .map((x) => polyLine2Reverse(planarGraphHalfEdgeStripToPolyLine2(graph.planarGraph, x)))
    .filter((x) => polyLine2WindingDir(x) === WindingDir.CCW);
}
